import React, { useEffect, useState } from "react";
import { useJobStore } from "@/dentlab/src/store/Jobs";
import { JobNoteCard } from "./job-note-card.component";
import { Plus } from "lucide-react";
import { Button } from "@/dentlab/src/components/ui/button";
import { JobNoteDialog } from "./job-note-dialog.component";

export const JobNotesPanel: React.FC = () => {
	const { job, jobNotes, jobNotesLoading, updateNote, deleteNote, fetchJobNotes, createNote } = useJobStore((state) => ({
		job: state.job,
		jobNotes: state.jobNotes,
		jobNotesLoading: state.jobNotesLoading,
		updateNote: state.updateNote,
		deleteNote: state.deleteNote,
		fetchJobNotes: state.fetchJobNotes,
		createNote: state.createNote,
	}));

	const [showAddNoteDialog, setShowAddNoteDialog] = useState(false);

	useEffect(() => {
		if (job?.id) {
			fetchJobNotes(job.id);
		}
	}, [job?.id]);

	if (!job) {
		return (
			<div className="p-4 text-center text-gray-500">
				Kein Auftrag ausgewählt
			</div>
		);
	}

	return (
		<div className="flex flex-col p-4 gap-2">
			<div className="flex items-center gap-2 justify-end">
				<Button
					size="sm"
					onClick={() => setShowAddNoteDialog(true)}
					className="flex items-center gap-2 h-8"
					variant="outline"
				>
					<Plus className="h-3.5 w-3.5" />
					<span>Notiz hinzufügen</span>
				</Button>
			</div>
			<div className="space-y-3">
				{jobNotesLoading ? (
					<div className="text-center text-sm text-gray-500 py-4">
						Notizen werden geladen...
					</div>
				) : jobNotes.length === 0 ? (
					<div className="text-center text-sm text-gray-500 py-8 border-2 border-dashed rounded-lg">
						Noch keine Notizen vorhanden
					</div>
				) : (
					jobNotes.map((note) => (
						<JobNoteCard
							key={note.id}
							note={note}
							onUpdate={updateNote}
							onDelete={deleteNote}
						/>
					))
				)}
			</div>
			<JobNoteDialog
				open={showAddNoteDialog}
				onClose={() => setShowAddNoteDialog(false)}
				onSave={async (content) => {
					if (job?.id) {
						await createNote(job.id, content);
						setShowAddNoteDialog(false);
					}
				}}
			/>
		</div>
	);
};